import React, { useEffect, useRef, useState } from 'react';
import { useContent } from 'hooks/useContent';
import ShareSocial from '../ShareSocial';

const KeyTrends = () => {
    const { content } = useContent();
    const keyTrends: any = content.keyTrends;
    const [flippedCards, setFlippedCards] = useState<{ [key: string]: boolean }>({});
    const [currentSlide, setCurrentSlide] = useState(0);
    const [offsetX, setOffsetX] = useState(0);

    const totalSlides = keyTrends.slides.length;
    const [slideWidth, setSlideWidth] = useState(0);
    const slideRef = useRef<HTMLDivElement | null>(null);
    const touchStartX = useRef(0);
    const isDragging = useRef(false);

    const handleFlip = (id: string, link?: string) => {
        if (link) return;

        setFlippedCards((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    const handleNextSlide = () => {
        if (currentSlide < totalSlides - 1) {
            setCurrentSlide((prevSlide) => prevSlide + 1);
            setOffsetX(0);
        }
        else {
            setCurrentSlide(0);
            setOffsetX(0);
        }
    };

    const handlePrevSlide = () => {
        if (currentSlide > 0) {
            setCurrentSlide((prevSlide) => prevSlide - 1);
            setOffsetX(0);
        }
        else {
            setCurrentSlide(totalSlides - 1);
            setOffsetX(0);
        }
    };

    const updateSlideWidth = () => {
        if (slideRef.current) {
            // const containerWidth = slideRef.current.parentElement?.clientWidth || 0;
            const slideWidth = slideRef.current.clientWidth;
            const visibleSlides = window.innerWidth >= 768 ? 3 : 1;
            const gap = window.innerWidth >= 768 ? 32 : 16;
            
            // Calculate the maximum translation to keep slides visible
            const maxTranslation = Math.max(0, (slideWidth + gap) * (totalSlides - visibleSlides));
            setSlideWidth(maxTranslation / (totalSlides - 1));
        }
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        const touch = e.touches[0];
        if (touch) {
            touchStartX.current = touch.clientX;
            isDragging.current = true;
        }
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        if (!isDragging.current) return;
        const touch = e.touches[0];
        if (touch) {
            const touchMoveX = touch.clientX;
            const deltaX = touchMoveX - touchStartX.current;

            // İlk slayttayken sola, son slayttayken sağa fazla kaymayı sınırlıyoruz
            if ((currentSlide === 0 && deltaX > 0) || (currentSlide === totalSlides - 1 && deltaX < 0)) {
                setOffsetX(deltaX / 4); // Sınırlı kaydırma efekti için direnç ekliyoruz
            } else {
                setOffsetX(deltaX);
            }
        }
    };

    const handleTouchEnd = () => {
        isDragging.current = false;

        if (offsetX < -slideWidth / 4 && currentSlide < totalSlides - 1) {
            handleNextSlide();
        } else if (offsetX > slideWidth / 4 && currentSlide > 0) {
            handlePrevSlide();
        } else {
            setOffsetX(0);
        }
    };

    useEffect(() => {
        updateSlideWidth();
        window.addEventListener('resize', updateSlideWidth);

        return () => {
            window.removeEventListener('resize', updateSlideWidth);
        };
    }, []);

    const isFlipped = (index: number) => {
        return flippedCards[index] || false;
    }

    // const isActive = (index: number) => {
    //     return index === currentSlide;
    // }

    return (
        <section id="key-trends" className="section-regular bg-brown">

            <div className="container-large">
                <div className="heading-wrap">
                    <div className="limited-heading-set">
                        <div className="tagline-heading">{keyTrends.tagline}</div>
                        <div className="heading-set-3">
                            <h2 className="h3-heading">{keyTrends.heading}</h2>
                            <div className="description">{keyTrends.description}</div>
                        </div>
                    </div>
                    <div className="action-side">
                        <ShareSocial />
                    </div>
                </div>
                <div
                    data-delay="4000"
                    data-animation="slide"
                    className="testimonial-slider w-slider"
                    data-autoplay="false"
                    data-easing="ease"
                    data-hide-arrows="false"
                    data-disable-swipe="false"
                    data-autoplay-limit="0"
                    data-nav-spacing="3"
                    data-duration="500"
                    data-infinite="true"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className="mask w-slider-mask">
                        <div className="slide w-slide"
                            style={{
                                transform: `translateX(${-currentSlide * slideWidth + offsetX}px)`,
                                transition: isDragging.current ? 'none' : 'transform 500ms ease',
                            }}
                            ref={slideRef}>
                            <div id="w-node-_0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850-50c80850" data-wf--flipping-card--variant="light-blue" data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850"
                                className={`flipcard-wrapper ${isFlipped(0) ? 'flipped' : ''}`}>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80851" className="flipcard-front w-variant-55eccf39-55bf-c903-8cdd-613e5f443a1b"><img src="/images/FDI-Strategy_1.webp" loading="lazy" alt=""  className="flipping-card-image" />
                                    <div className="tagline-heading-2 turqoise">{keyTrends.slides[0].tagline}</div>
                                    <h3 className="flipcard-title w-variant-55eccf39-55bf-c903-8cdd-613e5f443a1b">{keyTrends.slides[0].title}</h3>
                                    <div className="description white mini w-variant-55eccf39-55bf-c903-8cdd-613e5f443a1b">{keyTrends.slides[0].description}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085a" className="flipcard-more" onClick={() => handleFlip("0")}><span className="fa-solid-span"></span></div>
                                    <a data-wf--primary-button--variant="ghost-on-dark" 
                                       href={keyTrends.slides[0].link || "#"} 
                                       target={keyTrends.slides[0].link ? "_blank" : "_self"} className="animated-button w-variant-75a3490c-883a-9c9a-4045-2a43c7f804a3 w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[0].button}</div>
                                    </a>
                                </div>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085d" className="flipcard-fdi-target-back w-variant-55eccf39-55bf-c903-8cdd-613e5f443a1b">
                                    <h2 className="h4-heading">{keyTrends.slides[0].backTitle}</h2>
                                    <div className="description mini">{keyTrends.slides[0].backDescription}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80863" className="flipcard-less" onClick={() => handleFlip("0")}><span className="fa-solid-span dark"></span></div><img src="/images/FDI-Strategy_1.webp" loading="lazy" alt=""  className="flipping-card-image back" />
                                    <a data-wf--primary-button--variant="base"  href={keyTrends.slides[0].link || "#"} 
                                       target={keyTrends.slides[0].link ? "_blank" : "_self"} className="animated-button w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[0].backButton}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="slide w-slide"
                            style={{
                                transform: `translateX(${-currentSlide * slideWidth + offsetX}px)`,
                                transition: isDragging.current ? 'none' : 'transform 500ms ease',
                            }}>
                            <div id="w-node-_0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850-50c80850" data-wf--flipping-card--variant="green" data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850"
                                className={`flipcard-wrapper ${isFlipped(1) ? 'flipped' : ''}`}>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80851" className="flipcard-front w-variant-fe704ff9-d71d-7fc2-3bad-aada5fb2bad9"><img src="/images/Startup-Ecosystem_1.webp" loading="lazy" alt=""  className="flipping-card-image" />
                                    <div className="tagline-heading-2 turqoise w-variant-fe704ff9-d71d-7fc2-3bad-aada5fb2bad9">{keyTrends.slides[1].tagline}</div>
                                    <h3 className="flipcard-title">{keyTrends.slides[1].title}</h3>
                                    <div className="description white mini">{keyTrends.slides[1].description}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085a" className="flipcard-more" onClick={() => handleFlip("1")}><span className="fa-solid-span w-variant-fe704ff9-d71d-7fc2-3bad-aada5fb2bad9"></span></div>
                                    <a data-wf--primary-button--variant="ghost" 
                                     href={keyTrends.slides[1].link || "#"} 
                                     target={keyTrends.slides[1].link ? "_blank" : "_self"}
                                    className="animated-button w-variant-75dd7ef5-e54a-1afa-2e4d-50e2fb658872 w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[1].button}</div>
                                    </a>
                                </div>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085d" className="flipcard-fdi-target-back">
                                    <h2 className="h4-heading">{keyTrends.slides[1].backTitle}</h2>
                                    <div className="description mini">{keyTrends.slides[1].backDescription}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80863" className="flipcard-less" onClick={() => handleFlip("1")}><span className="fa-solid-span w-variant-55eccf39-55bf-c903-8cdd-613e5f443a1b"></span></div><img src="/images/Startup-Ecosystem_1.webp" loading="lazy" alt=""  className="flipping-card-image back" />
                                    <a data-wf--primary-button--variant="base"   href={keyTrends.slides[1].link || "#"} 
                                     target={keyTrends.slides[1].link ? "_blank" : "_self"} className="animated-button w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[1].backButton}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="slide w-slide" style={{
                            transform: `translateX(${-currentSlide * slideWidth + offsetX}px)`,
                            transition: isDragging.current ? 'none' : 'transform 500ms ease',
                        }}>
                            <div id="w-node-_0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850-50c80850" data-wf--flipping-card--variant="light-parliament" data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850"  className={`flipcard-wrapper ${isFlipped(2) ? 'flipped' : ''}`}>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80851" className="flipcard-front w-variant-f0886136-c0fd-9e3c-6fe0-2cf5834d9206"><img src="/images/Gaming-Ecosystem_1.webp" loading="lazy" alt=""  className="flipping-card-image" />
                                    <div className="tagline-heading-2">{keyTrends.slides[2].tagline}</div>
                                    <h3 className="flipcard-title">{keyTrends.slides[2].title}</h3>
                                    <div className="description white mini">{keyTrends.slides[2].description}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085a" className="flipcard-more"  onClick={() => handleFlip("2")}><span className="fa-solid-span"></span></div>
                                    <a data-wf--primary-button--variant="ghost" 
                                       href={keyTrends.slides[2].link || "#"} 
                                       target={keyTrends.slides[2].link ? "_blank" : "_self"} 
                                       className="animated-button w-variant-75dd7ef5-e54a-1afa-2e4d-50e2fb658872 w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[2].button}</div>
                                    </a>
                                </div>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085d" className="flipcard-fdi-target-back">
                                    <h2 className="h4-heading">{keyTrends.slides[2].backTitle}</h2>
                                    <div className="description mini">{keyTrends.slides[2].backDescription}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80863" className="flipcard-less"  onClick={() => handleFlip("2")}><span className="fa-solid-span dark"></span></div><img src="/images/Gaming-Ecosystem_1.webp" loading="lazy" alt=""  className="flipping-card-image back" />
                                    <a data-wf--primary-button--variant="base"   href={keyTrends.slides[2].link || "#"} 
                                       target={keyTrends.slides[2].link ? "_blank" : "_self"}  className="animated-button w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[2].backButton}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="slide w-slide" style={{
                            transform: `translateX(${-currentSlide * slideWidth + offsetX}px)`,
                            transition: isDragging.current ? 'none' : 'transform 500ms ease',
                        }}>
                            <div id="w-node-_0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850-50c80850" data-wf--flipping-card--variant="cream" data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850"  className={`flipcard-wrapper ${isFlipped(3) ? 'flipped' : ''}`}>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80851" className="flipcard-front w-variant-3a7d55c2-4490-ee85-53d9-638bfdd2ed9de"><img src="/images/Fintech-Ecosystem_1.webp" loading="lazy" alt=""  className="flipping-card-image" />
                                    <div className="tagline-heading-2">{keyTrends.slides[3].tagline}</div>
                                    <h3 className="flipcard-title ">{keyTrends.slides[3].title}</h3>
                                    <div className="description white mini w-variant-3a7d55c2-4490-ee85-53d9-638bfdd2ed9d">{keyTrends.slides[3].description}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085a" className="flipcard-more"  onClick={() => handleFlip("3")}><span className="fa-solid-span"></span></div>
                                    <a data-wf--primary-button--variant="ghost-on-dark" 
                                       href={keyTrends.slides[3].link || "#"} 
                                       target={keyTrends.slides[3].link ? "_blank" : "_self"} className="animated-button w-variant-75a3490c-883a-9c9a-4045-2a43c7f804a3 w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[3].button}</div>
                                    </a>
                                </div>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085d" className="flipcard-fdi-target-back">
                                    <h2 className="h4-heading">{keyTrends.slides[3].backTitle}</h2>
                                    <div className="description mini">{keyTrends.slides[3].backDescription}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80863" className="flipcard-less"  onClick={() => handleFlip("3")}><span className="fa-solid-span dark"></span></div><img src="/images/Fintech-Ecosystem_1.webp" loading="lazy" alt=""  className="flipping-card-image back" />
                                    <a data-wf--primary-button--variant="base"  href={keyTrends.slides[3].link || "#"} 
                                       target={keyTrends.slides[3].link ? "_blank" : "_self"} className="animated-button w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[3].backButton}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="slide w-slide" style={{
                            transform: `translateX(${-currentSlide * slideWidth + offsetX}px)`,
                            transition: isDragging.current ? 'none' : 'transform 500ms ease',
                        }}>
                            <div id="w-node-_0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850-50c80850" data-wf--flipping-card--variant="cream" data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850"  className={`flipcard-wrapper ${isFlipped(4) ? 'flipped' : ''}`}>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80851" className="flipcard-front w-variant-3a7d55c2-4490-ee85-53d9-638bfdd2ed9d"><img src="/images/FDI-Glossary_1.webp" loading="lazy" alt=""  className="flipping-card-image" />
                                    <div className="tagline-heading-2 turqoise">{keyTrends.slides[4].tagline}</div>
                                    <h3 className="flipcard-title w-variant-3a7d55c2-4490-ee85-53d9-638bfdd2ed9d">{keyTrends.slides[4].title}</h3>
                                    <div className="description white mini w-variant-3a7d55c2-4490-ee85-53d9-638bfdd2ed9d">{keyTrends.slides[4].description}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085a" className="flipcard-more"  onClick={() => handleFlip("4")}><span className="fa-solid-span"></span></div>
                                    <a data-wf--primary-button--variant="ghost-on-dark" 
                                       href={keyTrends.slides[4].link || "#"} 
                                       target={keyTrends.slides[4].link ? "_blank" : "_self"} className="animated-button w-variant-75a3490c-883a-9c9a-4045-2a43c7f804a3 w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[4].button}</div>
                                    </a>
                                </div>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085d" className="flipcard-fdi-target-back">
                                    <h2 className="h4-heading">{keyTrends.slides[4].backTitle}</h2>
                                    <div className="description mini">{keyTrends.slides[4].backDescription}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80863" className="flipcard-less"  onClick={() => handleFlip("4")}><span className="fa-solid-span dark"></span></div><img src="/images/FDI-Glossary_1.webp" loading="lazy" alt=""  className="flipping-card-image back" />
                                    <a data-wf--primary-button--variant="base"  href={keyTrends.slides[4].link || "#"} 
                                       target={keyTrends.slides[4].link ? "_blank" : "_self"} className="animated-button w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[4].backButton}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="slide w-slide" style={{
                            transform: `translateX(${-currentSlide * slideWidth + offsetX}px)`,
                            transition: isDragging.current ? 'none' : 'transform 500ms ease',
                        }}>
                            <div id="w-node-_0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850-50c80850" data-wf--flipping-card--variant="base" data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80850"  className={`flipcard-wrapper ${isFlipped(5) ? 'flipped' : ''}`}>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80851" className="flipcard-front"><img src="/images/FDI-Strategy_1.webp" loading="lazy" alt=""  className="flipping-card-image" />
                                    <div className="tagline-heading-2 turqoise">{keyTrends.slides[5].tagline}</div>
                                    <h3 className="flipcard-title">{keyTrends.slides[5].title}</h3>
                                    <div className="description white mini">{keyTrends.slides[5].description}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085a" className="flipcard-more"  onClick={() => handleFlip("5")} ><span className="fa-solid-span"></span></div>
                                    <a data-wf--primary-button--variant="ghost" 
                                       href={keyTrends.slides[5].link || "#"} 
                                       target={keyTrends.slides[5].link ? "_blank" : "_self"}
                                    className="animated-button w-variant-75dd7ef5-e54a-1afa-2e4d-50e2fb658872 w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[5].button}</div>
                                    </a>
                                </div>
                                <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c8085d" className="flipcard-fdi-target-back">
                                    <h2 className="h4-heading">{keyTrends.slides[5].backTitle}</h2>
                                    <div className="description mini">{keyTrends.slides[5].backDescription}</div>
                                    <div data-w-id="0a1fd4a4-3d6c-46b1-9dcd-ebd850c80863" className="flipcard-less"  onClick={() => handleFlip("5")}><span className="fa-solid-span dark"></span></div><img src="/images/FDI-Strategy_1.webp" loading="lazy" alt=""  className="flipping-card-image back" />
                                    <a data-wf--primary-button--variant="base"  href={keyTrends.slides[5].link || "#"} 
                                       target={keyTrends.slides[5].link ? "_blank" : "_self"} className="animated-button w-inline-block">
                                        <div className="body-button-normal">{keyTrends.slides[5].backButton}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="testimonial-arrow left w-slider-arrow-left" onClick={handlePrevSlide}
                        aria-hidden={currentSlide === 0 ? "true" : "false"}>
                        <div className="fa-solid-span dark"></div>
                    </div>
                    <div className="testimonial-arrow right w-slider-arrow-right" onClick={handleNextSlide}
                        aria-hidden={currentSlide === totalSlides - 1 ? "true" : "false"}>
                        <div className="fa-solid-span dark"></div>
                    </div>
                    <div className="hide w-slider-nav w-round w-num"></div>
                </div>
            </div>
            <img
                src="/images/StripesBG.svg"
                loading="lazy"
                alt=""
                className="main-overlay opacity-50 flip"
            />
        </section>
    );
};

export default KeyTrends;
